/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_FORMATEURS(state, formateurs) {
    state.formateurs = formateurs
  },
  SET_FORMATIONS(state, formations) {
    state.formations = formations
  },
  SET_GROUPES(state, groupes) {
    state.groupes = groupes
  },
  ADD_ITEM(state, item) {
    state.users.unshift(item)
  },
  SET_USERS(state, users) {
    state.users = users
  },
  REMOVE_RECORD(state, itemId) {
      const userIndex = state.users.findIndex((u) => u.id == itemId)
      state.users.splice(userIndex, 1)
  },
  UPDATE_USERS(state, user) {
    const eventIndex = state.users.findIndex((e) => e.id == user.id)
    Object.assign(state.users[eventIndex], user)
},
}
